import React from 'react';
import styled from '@emotion/styled';

import { RetinaPicture } from 'client/components/RetinaPicture';
import { FallbackExtension, HeaderImageType } from '../types';
import { SCREEN_BREAKPOINTS } from '../../../constants';

const HeaderImageContainer = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    width: ${({ size }) => `${size - 20}px`};
    height: ${({ size }) => `${size - 20}px`};
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    width: 50%;
  }
`;

const HeaderRetinaPicture = styled(RetinaPicture)<{
  anchorPosition?: string;
  size?: number;
}>`
  position: absolute;
  top: 0;
  z-index: 1;
  ${({ anchorPosition }) => anchorPosition};

  height: 100%;
  width: 100%;

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    left: 50%;
    width: ${({ size }) => (size ? size - 60 : 0)}px;
    height: ${({ size }) => (size ? size - 60 : 0)}px;
    transform: translateX(-50%);
  }
`;

export const HeaderImage = ({
  image,
  alt,
}: {
  image: HeaderImageType;
  alt: string;
}) => {
  const { size, anchorPosition, fallbackExtension, imagePath } = image;
  return (
    <HeaderImageContainer size={size}>
      <HeaderRetinaPicture
        alt={alt}
        anchorPosition={anchorPosition}
        fallbackExtension={fallbackExtension as FallbackExtension}
        imagePath={imagePath}
        size={size}
      />
    </HeaderImageContainer>
  );
};
